export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ02.c7f0a125.mp3";